import { RadioSchedule } from '@/models/RadioTypes';

export const PAKKAFORM_ID = 'pakkaform';

export const BREAKPOINTS = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1224,
  xxl: 1536,
};
export const FAQFORM_ID = 'spurningar';

export const ALLOWED_CHANNELS = [
  'stod2',
  'sport',
  'sport2',
  'sport4',
  'golfstodin',
  'vodasport',
  'besta01',
  'besta02',
  'besta03',
  'syn',
  'synsport',
  'synsport2',
  'synsport3',
  'synsport4',
  'synsportviaplay',
  'synsportisland',
  'synsportisland2',
  'synsportisland3',
  'synsportisland4',
  'synsportisland5',
];

export const ALLOWED_LIVE_CHANNELS = [
  'sport',
  'sport2',
  'sport4',
  'golfstodin',
  'vodasport',
  'synsport',
  'synsport2',
  'synsport3',
  'synsport4',
  'synsport5',
  'synsport6',
  'synsportviaplay',
  'synsportisland',
  'synsportisland2',
  'synsportisland3',
  'synsportisland4',
  'synsportisland5',
];

export enum CHANNEL_NAMES {
  'beint' = 'Í beinni',
  'syn' = 'SÝN',
  'synsport' = 'SÝN Sport',
  'synsport2' = 'SÝN Sport 2',
  'synsport3' = 'SÝN Sport 3',
  'synsport4' = 'SÝN Sport 4',
  'synsport5' = 'SÝN Sport 5',
  'synsport6' = 'SÝN Sport 6',
  'synsportviaplay' = 'SÝN Sport Viaplay',
  'synsportisland' = 'SÝN Sport Ísland',
  'synsportisland2' = 'SÝN Sport Ísland 2',
  'synsportisland3' = 'SÝN Sport Ísland 3',
  'synsportisland4' = 'SÝN Sport Ísland 4',
  'synsportisland5' = 'SÝN Sport Ísland 5',
  'bio' = 'Bíó',
  'esport' = 'Esport',
  'golfstodin' = 'Sýn Sport 5',
  'stod3' = 'Sýn Fjölskylda',
  'pepsimax' = 'Sýn.is',
  'default' = 'Bein sjónvarp',
}

export const LANGUAGES = [
  {
    value: 'IS',
    label: 'Íslenska',
  },
  {
    value: 'EN',
    label: 'Enska',
  },
];

export const DEFAULT_LANGUAGE = 'is';

export const RADIO_ALT_LOGOS: { [key: string]: string } = {
  APPARATID: '/images/apparatid_alt_logo.jpg',
  BYLGJAN: '/images/bylgjan_alt_logo.jpg',
  COUNTRY: '/images/country_bylgjan_alt_logo.jpg',
  FM957: '/images/fm957_alt_logo.jpg',
  GULLBYLGJAN: '/images/gullbylgjan_alt_logo.jpg',
  ISLENSKA: '/images/islenska_bylgjan_alt_logo.jpg',
  LETTBYLGJAN: '/images/lett_bylgjan_alt_logo.jpg',
  X977: '/images/x977_alt_logo.jpg',
  '80S': '/images/80s_bylgjan_alt_logo.jpg',
};

export const DEFAULT_SCHEDULE = {
  weekday: '',
  title: 'Tónlist',
  description: '',
  photo: '',
  timeFrom: '',
  timeTo: '',
  showId: '',
  host: '',
} as RadioSchedule;

export const RADIO_COLORS: { [key: string]: { primary: string; secondary: string } } = {
  APPARATID: {
    primary: '#FBAD29',
    secondary: '#FFFFFF',
  },
  BYLGJAN: {
    primary: '#1B1B56',
    secondary: '#FFFFFF',
  },
  COUNTRY: {
    primary: '#1B1B56',
    secondary: '#E75E19',
  },
  FM957: {
    primary: '#3DA82E',
    secondary: '#FFFFFF',
  },
  GULLBYLGJAN: {
    primary: '#1B1B56',
    secondary: '#FDB813',
  },
  ISLENSKA: {
    primary: '#1B1B56',
    secondary: '#CD1A2E',
  },
  LETTBYLGJAN: {
    primary: '#1B1B56',
    secondary: '#00A7D4',
  },
  X977: {
    primary: '#000000',
    secondary: '#FFFFFF',
  },
  '80S': {
    primary: '#1F1A6B',
    secondary: '#8D3594',
  },
  '': {
    primary: '#1B1B56',
    secondary: '#FFFFFF',
  },
};

export const RADIO_1X1_LOGOS: { [key: string]: string } = {
  APPARATID: '/images/apparatid_1x1_logo.jpg',
  BYLGJAN: '/images/bylgjan_1x1_logo.jpg',
  COUNTRY: '/images/country_bylgjan_1x1_logo.jpg',
  FM957: '/images/fm957_1x1_logo.jpg',
  GULLBYLGJAN: '/images/gullbylgjan_1x1_logo.jpg',
  ISLENSKA: '/images/islenska_bylgjan_1x1_logo.jpg',
  LETTBYLGJAN: '/images/lett_bylgjan_1x1_logo.jpg',
  X977: '/images/x977_1x1_logo.jpg',
  '80S': '/images/80s_bylgjan_1x1_logo.jpg',
};

export enum RADIO_STATIONS {
  BYLGJAN = 'BYLGJAN',
  X977 = 'X977',
  FM957 = 'FM957',
  GULLBYLGJAN = 'GULLBYLGJAN',
  LETTBYLGJAN = 'LETTBYLGJAN',
  COUNTRY = 'COUNTRY',
  ISLENSKA = 'ISLENSKA',
  '80S' = '80S',
  UTVARP_101 = '101',
  FMEXTRA = 'FMEXTRA',
  APPARATID = 'APPARATID',
  RAS1 = 'RAS1',
  RAS2 = 'RAS2',
  RETRO = 'RETRO',
  K100 = 'K100',
  RONDO = 'RONDO',
  BBCWS = 'BBCWS',
  TROLLI = 'trolli',
}

export const TV_SCHEDULE_ROOT = 'https://tv-schedule-data.s3.eu-west-1.amazonaws.com/';

export const NETS_CONTRACTS = {
  WEBSTORE: 'WEB-STORE',
  MAIN: 'MAIN',
};

export const CATEGORY_NAME_MAP = {
  farsimar: 'Farsímar',
  snjallur: 'Snjallúr',
  spjaldtolvur: 'Spjaldtölvur',
  aukahlutir: 'Aukahlutir',
  endabunadur: 'Endabúnaður',
  heyrnatol: 'Heyrnartól',
  heyrnartol: 'Heyrnartól',
  bord: 'Borð',
  eign: 'Eign',
  fordi: 'Forði',
  frelsi: 'Frelsi',
  'gsm-tilbod': 'Farsíma tilboð',
  heimasimar: 'Heimasímar',
  'hugb-leyfi': 'Hubúnaðarleyfi',
  hysing: 'Hýsing',
  kaffihus: 'Kaffihús',
  mark: 'Mark',
  rekstarthjonusta: 'Rekstrarþjónusta',
  sim: 'SIM',
  skyjathjonusta: 'Skýjaþjónusta',
  snjallheimili: 'Snjallvörur',
  ymislegt: 'Ýmislegt',
  '': '',
} as Record<string, string>;

// Build was complaining about this not being initialized in the getServerSideProps
// when this was defined in @/config/constants - fb
export const CATEGORY_ID_MAP = {
  farsimar: 'GSM',
  snjallur: 'SNJALLÚR',
  spjaldtolvur: 'SPJALDTÖLV',
  aukahlutir: 'AUKAHLUTIR',
  endabunadur: 'ENDABÚNAÐ',
  heyrnatol: 'HEYRNARTÓL',
  heyrnartol: 'HEYRNARTÓL',
  bord: 'BORD',
  eign: 'EIGN',
  fordi: 'FORÐI',
  frelsi: 'FRELSI',
  'gsm-tilbod': 'GSM TILBOÐ',
  heimasimar: 'HEIMASÍMAR',
  'hugb-leyfi': 'HUGB_LEYFI',
  hysing: 'HÝSING',
  kaffihus: 'KAFFIHÚS',
  mark: 'MARK',
  rekstarthjonusta: 'REKSTR_THJ',
  sim: 'SIM',
  skyjathjonusta: 'SKYJATHJON',
  snjallheimili: 'SMARTHOME',
  ymislegt: 'ÝMISLEGT',
  '': '',
} as Record<string, string>;
